import type { ReactNode } from 'react'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
    root: {
        display: 'flex',
        minWidth: 0,
        alignItems: 'start',
        justifyContent: 'space-between',
        gap: '12px',
    },
    copy: {
        minWidth: 0,
        flex: '1 1 0%',
    },
    action: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
    },
    eyebrow: {
        color: '#5e8e68',
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '.08em',
    },
    title: {
        marginTop: '4px',
        overflowWrap: 'anywhere',
        fontSize: 'clamp(27px, 3vw, 32px)',
        fontWeight: 650,
        letterSpacing: '-.04em',
        lineHeight: '1.08',
    },
    subtitle: {
        maxWidth: '42rem',
        marginTop: '6px',
        color: '#748077',
        fontSize: '13px',
        lineHeight: '1.2rem',
    },
})

type PageHeaderProps = {
    action?: ReactNode
    eyebrow?: string
    subtitle?: string
    title: string
}

export default function PageHeader({ action, eyebrow, subtitle, title }: PageHeaderProps) {
    return (
        <header {...stylex.props(styles.root)}>
            <div {...stylex.props(styles.copy)}>
                {eyebrow && <p {...stylex.props(styles.eyebrow)}>{eyebrow}</p>}
                <h1 {...stylex.props(styles.title)}>{title}</h1>
                {subtitle && <p {...stylex.props(styles.subtitle)}>{subtitle}</p>}
            </div>
            {action && <div {...stylex.props(styles.action)}>{action}</div>}
        </header>
    )
}
